import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";
import { SendToNewsEmbed } from "./SendToNewsEmbed";
import "./video-player.m.css";

export const HomeVideoPlacement = ({ videoAdCode }) => {
  const [targetNode, setTargetNode] = useState(null);

  useEffect(() => {
    // Determine the mount target based on screen width
    const mobileTarget = document.getElementById("mobile-video-target");
    const desktopTarget = document.getElementById("desktop-video-target");

    if (window.innerWidth >= 1025) {
      setTargetNode(desktopTarget);
    } else {
      setTargetNode(mobileTarget);
    }
  }, []);

  if (!targetNode) return null;

  const playerContent = (
    <div styleName="video-player" className="video-player">
      <SendToNewsEmbed videoAdCode={videoAdCode} />
    </div>
  );

  return createPortal(playerContent, targetNode);
};

HomeVideoPlacement.propTypes = {
  videoAdCode: PropTypes.string,
};

export default HomeVideoPlacement;
